import React, { Component } from 'react';
import { Popover } from 'antd';
import TableC from '../../../../basicElement/TableC';
import renderEnhancer from '../../../../shared/renderEnhancer';
import format from '../../../../shared/format';
import Fetch from '../../../../../common/Fetch';
import API_URL from '../../../../../common/url';

const KeyNameMap = {
    '0': '正常',
    '1': '异常',
};

class list extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { searchParams: nextSearchParams } = nextProps;
        const { searchParams } = this.props;
        if (nextSearchParams !== searchParams) {
            return false;
        }
        return true;
    }

    componentDidMount() {
        this.loadData();
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.load !== this.props.load) {
            this.loadData();
        }
    }

    loadData = () => {
        const { pagination, sortParams, searchParams, activeKey, onChange } = this.props;
        const { current, pageSize } = pagination;

        this.setState({ loading: true });
        Fetch.post(API_URL.requestDataAnalysis.queryInvoiceData, {
            offset: current,
            limit: 10,
            ...sortParams,
            ...searchParams,
            type: activeKey,
        }).then(res => {
            const { datas, totalCount } = res;
            const data = this.getDataSource(datas);
            const len = data.length;
            const pageSize = len <= 11 ? 11 : len;
            pagination.pageSize = pageSize;
            pagination.total = totalCount + (pageSize - 10) * Math.ceil(totalCount / 10);
            onChange({ pagination });
            this.setState({
                data,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    getColumns = () => {
        const { activeKey } = this.props;
        const columns = [{
            title: '请款单号',
            dataIndex: 'remittanceCode',
            key: 'remittanceCode',
            fixed: 'left',
            width: 100,
            render: renderEnhancer((text, record) => {
                if (text === '合计') return text;
                return <a onClick={() => this.handleClick(record)}>{text}</a>;
            })
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 160,
            render: renderEnhancer(),
        }, {
            title: 'JDE主项目号',
            dataIndex: 'investigationJdeMainCode',
            key: 'investigationJdeMainCode',
            width: 100,
            render: renderEnhancer(),
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusiness',
            key: 'lineOfBusiness',
            width: 100,
            render: renderEnhancer(),
        }, {
            title: 'JDE项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            width: 100,
            render: renderEnhancer(),
        }, {
            title: '计收入确认方式',
            dataIndex: 'contractTypeValue',
            key: 'contractTypeValue',
            width: 120,
            render: renderEnhancer(),
        }, {
            title: '客户付款单位',
            dataIndex: 'customerCompanyName',
            key: 'customerCompanyName',
            width: 120,
            render: renderEnhancer(),
        }, {
            title: '请款笔数',
            dataIndex: 'remittanceNum',
            key: 'remittanceNum',
            width: 100,
            render: renderEnhancer((text, record) => {
                const { remittanceCode } = record;
                if (remittanceCode === '合计') {
                    return (
                        <Popover
                            placement="top"
                            overlayClassName="contract-pop"
                            content={`${KeyNameMap[activeKey]}开票的笔数/所有已开票的笔数`}
                        >
                            <div>
                                <i className='pop'></i>
                                {text}
                            </div>
                        </Popover>
                    );
                }
                return text;
            })
        }, {
            title: '请款节点',
            dataIndex: 'cashReqNode',
            key: 'cashReqNode',
            width: 120,
            render: renderEnhancer((text, record) => {
                const { cashReqNodeType, cashReqNodeNum } = record;
                let remark = '';
                if (cashReqNodeType) {
                    remark = cashReqNodeType === 'NNF' ? `(${cashReqNodeNum}例)` : `(合同开始后${cashReqNodeNum}天)`;
                }
                return text ? `${text}${remark}` : '';
            }),
        }, {
            title: '合同约定请款金额/人民币(元)',
            dataIndex: 'remittanceAmount',
            key: 'remittanceAmount',
            width: 120,
            render: renderEnhancer(text => format('money', text)),
        }, {
            title: 'milestone到达日期',
            dataIndex: 'cashReqNodeDate',
            key: 'cashReqNodeDate',
            width: 100,
            render: renderEnhancer(text => format('date', text))
        }, {
            title: '确认可请款日期',
            dataIndex: 'baConfirmCashReqDate',
            key: 'baConfirmCashReqDate',
            width: 100,
            render: renderEnhancer(text => format('date', text))
        }, {
            title: '开票日期',
            dataIndex: 'invoiceDate',
            key: 'invoiceDate',
            sorter: true,
            width: 100,
            render: (text, record) => {
                const { rowSpan, markRed } = record;
                return <span style={{ color: (rowSpan !== 1 || markRed === 1) && 'red'}}>{format('date', text)}</span>;
            }
        }, {
            title: '发票金额(含税总额)总金额',
            dataIndex: 'invoiceMoney',
            key: 'invoiceMoney',
            width: 160,
            render: (text, record) => {
                const { rowSpan, markRed, remittanceCode } = record;

                text = format('money', text);
                if (remittanceCode === '合计') {
                    return (
                        <Popover
                            placement="top"
                            overlayClassName="contract-pop"
                            content={`${KeyNameMap[activeKey]}开票的金额/所有已开票的金额`}
                        >
                            <div>
                                <i className='pop'></i>
                                {text}
                            </div>
                        </Popover>
                    );
                }
                return <span style={{ color: (rowSpan !== 1 || markRed === 1) && 'red'}}>{text}</span>;
            },
        }, {
            title: '未开票原因',
            dataIndex: 'remark',
            key: 'remark',
            width: 160,
            render: renderEnhancer(),
        }];
        return columns;
    }

    getDataSource = (data) => {
        const dataSource = [];
        (data || []).forEach(d => {
            const { records } = d;
            const list = records;
            const len = (list || []).length;
            if (len) {
                list.forEach((item, index) => {
                    const { invoiceDate, grossAmount, invoiceBaName, contractBackRecordId } = item;
                    const setting = {};
                    if (invoiceBaName) {
                        setting.invoiceBaName = invoiceBaName;
                    }
                    dataSource.push({
                        ...d,
                        ...setting,
                        invoiceDate,
                        invoiceMoney: grossAmount,
                        rowSpan: index === 0 ? len : 0,
                        rowId: `${d.contractRemittanceApplicationId}-${contractBackRecordId}`
                    });
                });
            } else {
                dataSource.push({
                    ...d,
                    rowSpan: 1,
                    rowId: d.contractRemittanceApplicationId
                });
            }
        });
        return dataSource;
    }

    handleClick = (record) => {
        const { notice } = this.props;
        const { remittanceCode } = record;
        notice.saveParams({ remittanceCode });
        location.href = '/#/contractManagement/requestRecord';
    }

    handleChange = (params) => {
        this.props.onChange(params, true);
    }

    render() {
        const { height, pagination, sortParams } = this.props;
        const { data, loading } = this.state;
        return (
            <div>
                <TableC
                    data={data}
                    scrollY={height}
                    loading={loading}
                    rowKey="rowId"
                    sortParams={sortParams}
                    pagination={pagination}
                    onChange={this.handleChange}
                    columns={this.getColumns()}
                    className="invoiceData"
                />
            </div>
        );
    }
}

export default list;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestToDo/InvoiceData/TablePage/List.js